export interface DynamicFormInputQuestion {
  key: string;
  title: string;
  type: string;
  required: boolean;
  readonly?: boolean;
  // TODO: implements conditionnal questions based on logic options
  logic?: QuestionLogic;
  customClasses?: string[];
  order?: number;
  class_id?: string;
  date_format?: string;
  min?: string;
  max?: string;
  color?: string;
  startLabel?: string;
  endLabel?: string;
  dualKnobs?: boolean;
  options?: QuestionOption[];
  display?: boolean;
  conditionnalRules: any[];
}

interface QuestionLogic {
  action: string;
  checks: [];
  conditionnal: string;
}

interface QuestionOption {
  value: string;
  name: string;
  color?: string;
}
